<div class="mappings-page">
  <div class="mappings-header">
    <div>
      <h1>Country blockchain mappings</h1>
      <p>Which network each country's companies write to.</p>
    </div>
    @if (canEdit) {
      <button mat-flat-button class="btn-submit" (click)="openUpsertDialog()">
        <mat-icon>add</mat-icon>
        New mapping
      </button>
    }
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (mappings().length === 0) {
    <app-empty-state message="No country mappings configured yet." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Country</th>
          <th>Network</th>
          <th>Schema profile</th>
          <th>Updated</th>
        </tr>
      </thead>
      <tbody>
        @for (m of mappings(); track m.countryCode) {
          <tr>
            <td>{{ m.countryCode }}</td>
            <td>{{ m.network }}</td>
            <td>{{ m.schemaProfile }}</td>
            <td>{{ m.updatedAt | date: 'medium' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
